export const SET_RATESHEET_TABLE_RECORDS          = "SET_RATESHEET_TABLE_RECORDS";
export const UPDATE_RATESHEET_TABLE_RECORDS       = "UPDATE_RATESHEET_TABLE_RECORDS";
export const RESET_RATESHEET_TABLE_RECORDS        = "RESET_RATESHEET_TABLE_RECORDS";
export const UPDATE_RATESHEET_PAYLOAD             = "UPDATE_RATESHEET_PAYLOAD";
export const UPDATE_RATESHEET_CELLS               = "UPDATE_RATESHEET_CELLS"; 
export const SELECT_RATESHEET_ROWS                = "SELECT_RATESHEET_ROWS";
export const CLEAR_OR_SELECT_ALL_ROWS             = "CLEAR_OR_SELECT_ALL_ROWS"; 